:host {
  --gray-12:            #F8F8F8;
  --gray-13:            #e6f0ff;
  --neutral-100:        #F4F4F5;
  --pill-background: var(--gray-12);
  --pill-background-active: var(--gray-13);
}

@media (prefers-color-scheme: dark) {
  :host {
    --pill-background: var(--primary-black);
    --pill-background-active: var(--neutral-100);
  }
}

/* Interests Step */
.interests-container {
  display: flex;
  margin: 0;
  padding: 0px;
  justify-content: center;
  align-items: flex-start;
  align-content: flex-start;
  gap: 8px;
  align-self: stretch;
  flex-wrap: wrap;
}

.auth-container .step-container.interests {
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  gap: 24px
}

.interests .form-body {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  padding: 0px;

  @media(max-width: 1040px) {
    max-height: 50dvh;
    overflow: scroll;
  }
}

.interest-pill {
  display: flex;
  height: 36px;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 28px;
  border: 1px solid var(--gray-4);
  background: var(--pill-background);
  font-family: var(--body-font);
  color: var(--text-body);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.interest-pill.active {
  border-color: var(--primary);
  background-color: var(--pill-background-active);
  color: var(--primary);
  font-weight: 500;
}

.visually-hidden {
  display: none;
}

.interests .step-actions button:disabled {
  cursor: not-allowed;
  background-color: var(--primary-70);
  border-color: var(--primary-70);
}